export const SERVER_URI = process.env.NODE_ENV === "development" ? "http://localhost:30678" : process.env.REACT_APP_API_URL